import React from 'react';

/**
 * When a Recently rented buyer is due back to buying (George Bottas,
 * CRM-2026-00132). Same ids as RENTED_RETURN_OPTIONS on the backend. There is
 * no "indefinite": the point is a date to call them again.
 */
const RENTED_RETURN_CHOICES = [
  { id: '6m', label: '6 months' },
  { id: '12m', label: '12 months' },
  { id: 'date', label: 'Choose a date' },
];

export const DEFAULT_RENTED_RETURN = '12m';

const pill = (selected) =>
  `px-3 py-1.5 rounded-full border text-xs font-semibold transition-colors ${
    selected
      ? 'bg-[#E0F7FA] border-[#2DC8DB] text-[#00838F]'
      : 'bg-white border-gray-200 text-gray-600 hover:border-[#55C5D0]'
  }`;

const tomorrow = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
};

/** Controlled: the caller keeps `option` and `date`. */
export default function RentedReturnPicker({ option, date, onOptionChange, onDateChange }) {
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {RENTED_RETURN_CHOICES.map(({ id, label }) => (
          <button key={id} type="button" className={pill(option === id)} onClick={() => onOptionChange(id)}>
            {label}
          </button>
        ))}
      </div>
      {option === 'date' && (
        <input
          type="date"
          aria-label="Back to buying on"
          value={date || ''}
          min={tomorrow()}
          onChange={(e) => onDateChange(e.target.value)}
          className="rounded-md border border-gray-200 px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-[#55C5D0]"
        />
      )}
    </div>
  );
}
